import httpClient from "../../axios";
import { DAS_API } from "../das-device-manager/dasDeviceManagerService";

const getGuestTickets = async ({ eventId, guestId }) => {
  const response = await httpClient.get(
    `${DAS_API}/events/${eventId}/features/tickets/guests/${guestId}`,
  );

  return response.data;
};

const activateWearableTicket = async ({ eventId, serialNumber, ticketId }) => {
  const response = await httpClient.post(
    `${DAS_API}/events/${eventId}/features/tickets/wearables/${serialNumber}/tickets/${ticketId}/activate`,
  );

  return response.data;
};

const eventTicketsService = {
  getGuestTickets,
  activateWearableTicket,
};

export default eventTicketsService;
